export default {
  buttons: {
    title1: 'Crop',
    title2: 'Close',
  },
};
